export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '@modules/analysis/api/global';

const namespace = 'ANALYSIS';

export const SELECT_MARKET_AREA_RECORD = `${namespace}/SELECT_MARKET_AREA_RECORD`;

export const selectMarketAreaRecord = data => ({
  type: SELECT_MARKET_AREA_RECORD,
  data,
});

export const RESET_ACTIVE_RECORDS = `${namespace}/RESET_ACTIVE_RECORDS`;

export const resetActiveRecords = () => ({
  type: RESET_ACTIVE_RECORDS,
});

export const FETCH_ROLL_CORRECTIONS = createRequestTypes(
  `${namespace}/FETCH_ROLL_CORRECTIONS`,
);
export const fetchRollCorrections = makeApiActionCreatorV3(
  api.fetchRollCorrections,
  FETCH_ROLL_CORRECTIONS[START],
  FETCH_ROLL_CORRECTIONS[SUCCESS],
  FETCH_ROLL_CORRECTIONS[ERROR],
);
